import { useState as l, useEffect as u } from "react";
import { getMe as i } from "../services/me/getMe.js";
const m = t => {
  const [o, e] = l(!0),
    [r, a] = l({});
  return u(() => {
    if (t != null && t.cancelFetch) {
      e(!1);
      return;
    }
    const n = new AbortController();
    return e(!0), i(t == null ? void 0 : t.teamKey, n.signal).then(c => a(c)).finally(() => e(!1)), () => {
      n.abort();
    };
  }, [t == null ? void 0 : t.cancelFetch, t == null ? void 0 : t.teamKey]), {
    meIsLoading: o,
    meData: r
  };
};
export { m as useMe };